module.exports = __webpack_public_path__ + "bec09c1b901988bd0185ef50df81c968.png";